<template>
<layout-content>
  <template #toolbar>
    <el-date-picker
      v-model="query.date"
      type="month"
      format="yyyy年MM月"
      value-format="yyyy/MM"
      :clearable="false"
      :editable="false"
      :picker-options="pickerOptions"
      size="small"
      style="width:150px;"
      @change="onDateChange"
    />

    <el-button
      type="warning"
      icon="el-icon-document-add"
      size="small"
      style="margin-left:0;"
      @click="onCreateReportBtnClick"
    >生成</el-button>

    <el-button
      :disabled="!hasReport"
      type="primary"
      icon="el-icon-upload"
      size="small"
      style="margin-left:0;"
      @click="onSaveReportBtnClick"
    >保存</el-button>

    <el-button
      :disabled="!hasReport"
      type="success"
      icon="el-icon-download"
      size="small"
      style="margin-left:0;"
      @click="onExportReportBtnClick"
    >导出</el-button>
  </template>

  <template #body>
    <data-wrapper class="data-editor-wrapper">
      <div v-if="rawData" class="report-data-display-wrapper">
        <div v-if="rawData.monthSituation">
          <report-ring-chart :title="`图${chapterIndex.monthSituation}-1 ${rawData.monthSituation.dateStr} ${rawData.monthSituation.cityName}空气质量等级分布图`" :data="rawData.monthSituation.ringChart.dataList" />

          <div style="font-size:14px;margin-bottom:.5em;text-align:center;">常规4+2浓度统计</div>
          <table border="1" class="report-table">
            <thead>
            <tr>
              <th>
                <div style="line-height:1;text-align:right;">因子</div>
                <div style="line-height:1;text-align:left;">统计</div>
              </th>
              <th>PM₁₀<br/>(μg/m³)</th>
              <th>PM₂.₅<br/>(μg/m³)</th>
              <th>SO₂<br/>(μg/m³)</th>
              <th>NO₂<br/>(μg/m³)</th>
              <th>O₃<br/>(μg/m³)</th>
              <th>O₃_8h<br/>(μg/m³)</th>
              <th>CO<br/>(mg/m³)</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td align="center">最小值</td>
              <td align="center">{{rawData.monthSituation.pm10CalculateMap.min === 'NA' ? '/' : rawData.monthSituation.pm10CalculateMap.min}}</td>
              <td align="center">{{rawData.monthSituation.pm25CalculateMap.min === 'NA' ? '/' : rawData.monthSituation.pm25CalculateMap.min}}</td>
              <td align="center">{{rawData.monthSituation.so2CalculateMap.min === 'NA' ? '/' : rawData.monthSituation.so2CalculateMap.min}}</td>
              <td align="center">{{rawData.monthSituation.no2CalculateMap.min === 'NA' ? '/' : rawData.monthSituation.no2CalculateMap.min}}</td>
              <td align="center">{{rawData.monthSituation.o3CalculateMap.min === 'NA' ? '/' : rawData.monthSituation.o3CalculateMap.min}}</td>
              <td align="center">{{rawData.monthSituation.o38hCalculateMap.min === 'NA' ? '/' : rawData.monthSituation.o38hCalculateMap.min}}</td>
              <td align="center">{{rawData.monthSituation.coCalculateMap.min === 'NA' ? '/' : rawData.monthSituation.coCalculateMap.min}}</td>
            </tr>
            <tr>
              <td align="center">最大值</td>
              <td align="center">{{rawData.monthSituation.pm10CalculateMap.max === 'NA' ? '/' : rawData.monthSituation.pm10CalculateMap.max}}</td>
              <td align="center">{{rawData.monthSituation.pm25CalculateMap.max === 'NA' ? '/' : rawData.monthSituation.pm25CalculateMap.max}}</td>
              <td align="center">{{rawData.monthSituation.so2CalculateMap.max === 'NA' ? '/' : rawData.monthSituation.so2CalculateMap.max}}</td>
              <td align="center">{{rawData.monthSituation.no2CalculateMap.max === 'NA' ? '/' : rawData.monthSituation.no2CalculateMap.max}}</td>
              <td align="center">{{rawData.monthSituation.o3CalculateMap.max === 'NA' ? '/' : rawData.monthSituation.o3CalculateMap.max}}</td>
              <td align="center">{{rawData.monthSituation.o38hCalculateMap.max === 'NA' ? '/' : rawData.monthSituation.o38hCalculateMap.max}}</td>
              <td align="center">{{rawData.monthSituation.coCalculateMap.max === 'NA' ? '/' : rawData.monthSituation.coCalculateMap.max}}</td>
            </tr>
            </tbody>
          </table>

          <report-line-chart :title="`图${chapterIndex.monthSituation}-2 ${rawData.monthSituation.dateStr} AQI六参数时间序列图`" :param="rawData.monthSituation.timeSeriesChart" style="margin-top:1rem;" />
          <report-line-chart :title="`图${chapterIndex.monthSituation}-3 ${rawData.monthSituation.dateStr} 气象五参数时间序列图`" :param="rawData.monthSituation.weatherChart" style="margin-top:1rem;" />

          <report-ring-chart
            v-for="(siteStatus, index) in rawData.monthSituation.siteStatus"
            :key="siteStatus.siteId"
            :title="`图${chapterIndex.monthSituation}-${4 + index} ${rawData.monthSituation.dateStr} ${rawData.monthSituation.siteNameMap[siteStatus.siteId]}空气质量等级分布图`"
            :data="siteStatus.ringChart.dataList"
            style="margin-top:1rem;"
          />
        </div>

        <div v-if="rawData.monthAnalyzeMap">
          <report-line-chart
            :title="`图${chapterIndex.monthAnalyzeMap}-1 ${rawData.monthSituation.dateStr} O3及其前体物监测结果时间序列图`"
            :param="rawData.monthAnalyzeMap.o3PrecursorChart"
            style="margin-top:1rem;"
          />

          <report-line-chart
            :title="`图${chapterIndex.monthAnalyzeMap}-2 ${rawData.monthSituation.dateStr} VOCs组分监测结果时间序列图`"
            :param="rawData.monthAnalyzeMap.vocTo5Chart"
            style="margin-top:1rem;"
          />

          <div v-if="monthVOCsSortData">
            <div style="font-size:14px;margin:1rem 0 .5em;text-align:center;">VOCs物种浓度排序 TOP10</div>
            <table border="1" class="report-table">
              <thead>
              <tr>
                <th>因子</th>
                <th>物种浓度<br/>(ppb)</th>
              </tr>
              </thead>
              <tbody>
              <tr
                v-for="item in monthVOCsSortData.avgSortList"
                :key="item.id"
              >
                <td>{{item.name}}</td>
                <td>{{item.value}}</td>
              </tr>
              </tbody>
            </table>

            <div style="font-size:14px;margin:1rem 0 .5em;text-align:center;">VOCs对臭氧生成潜势 TOP10</div>
            <table border="1" class="report-table">
              <thead>
              <tr>
                <th>因子</th>
                <th>iofp</th>
              </tr>
              </thead>
              <tbody>
              <tr
                v-for="item in monthVOCsSortData.ofpSortList"
                :key="item.id"
              >
                <td>{{item.name}}</td>
                <td>{{item.iofp}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div v-if="rawData.yearSituationMap">
          <report-ring-chart
            :title="`图${chapterIndex.yearSituationMap}-1 截至${rawData.monthSituation.dateStr}末${rawData.monthSituation.cityName}空气质量等级分布图`"
            :data="rawData.yearSituationMap.ringChart.dataList"
            style="margin-top:1rem;"
          />

          <report-ring-chart
            v-for="(siteStatus, index) in rawData.yearSituationMap.siteStatus"
            :key="siteStatus.siteId"
            :title="`图${chapterIndex.yearSituationMap}-${2 + index} 截至${rawData.monthSituation.dateStr}末${rawData.monthSituation.siteNameMap[siteStatus.siteId]}空气质量等级分布图`"
            :data="siteStatus.ringChart.dataList"
            style="margin-top:1rem;"
          />
        </div>

        <div v-if="rawData.yearAnalyzeMap">
          <report-line-chart
            :title="`图${chapterIndex.yearAnalyzeMap}-1 ${rawData.monthSituation.dateStr} O3及其前体物监测结果时间序列图`"
            :param="rawData.yearAnalyzeMap.o3PrecursorChart"
            style="margin-top:1rem;"
          />

          <report-line-chart
            :title="`图${chapterIndex.yearAnalyzeMap}-2 ${rawData.monthSituation.dateStr} VOCs组分监测结果时间序列图`"
            :param="rawData.yearAnalyzeMap.vocTo5Chart"
            style="margin-top:1rem;"
          />

          <div v-if="yearVOCsSortData">
            <div style="font-size:14px;margin:1rem 0 .5em;text-align:center;">VOCs物种浓度排序 TOP10</div>
            <table border="1" class="report-table">
              <thead>
              <tr>
                <th>因子</th>
                <th>物种浓度<br/>(ppb)</th>
              </tr>
              </thead>
              <tbody>
              <tr
                v-for="item in yearVOCsSortData.avgSortList"
                :key="item.id"
              >
                <td>{{item.name}}</td>
                <td>{{item.value}}</td>
              </tr>
              </tbody>
            </table>

            <div style="font-size:14px;margin:1rem 0 .5em;text-align:center;">VOCs对臭氧生成潜势 TOP10</div>
            <table border="1" class="report-table">
              <thead>
              <tr>
                <th>因子</th>
                <th>iofp</th>
              </tr>
              </thead>
              <tbody>
              <tr
                v-for="item in yearVOCsSortData.ofpSortList"
                :key="item.id"
              >
                <td>{{item.name}}</td>
                <td>{{item.iofp}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="html-content-editor-wrapper">
        <div class="html-content-editor-inner">
          <vue-ueditor-wrap v-model="htmlContent" :config="editorConfig" class="html-content-editor" />
        </div>
      </div>
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseWordEditor from '../BaseWordEditor'
import LayoutContent from '../../../../components/Layout/Content'
import DataWrapper from '../../../../components/Data/DataWrapper'
import ReportRingChart from '../../../../components/ReportChart/ReportRingChart'
import ReportLineChart from '../../../../components/ReportChart/ReportLineChart'

export default {
  name: 'MonthReport',
  routeInfo: {
    label: '月报',
    icon: 'fa fa-users'
  },
  extends: BaseWordEditor,
  components: {ReportLineChart, ReportRingChart, DataWrapper, LayoutContent},
  computed: {
    apiKey: () => 'Report',
    pickerOptions: () => ({
      disabledDate: time => {
        const currentMonth = new Date()
        currentMonth.setDate(1)
        currentMonth.setHours(0, 0, 0, 0)
        return time >= currentMonth
      }
    }),
    monthVOCsSortData () {
      const {monthAnalyzeMap} = this.rawData

      if (monthAnalyzeMap) {
        const {keyComponentFactorMap, vocRankingList} = monthAnalyzeMap
        const keyComponentFactorDataList = vocRankingList.reduce((list, data) => {
          for (let factorId in data) {
            const factor = keyComponentFactorMap[factorId]
            const factorData = data[factorId]

            if (factor) {
              const {mir} = factor

              if (mir) {
                const {avg} = factorData

                list.push({
                  id: factorId,
                  name: factorData.name,
                  unit: factor.stdUnit,
                  value: avg,
                  iofp: Number((avg * mir).toFixed(3)),
                  mir
                })
              }
            }
          }

          return list
        }, [])

        return {
          avgSortList: [...keyComponentFactorDataList].sort((a, b) => b.value - a.value).slice(0, 10),
          ofpSortList: [...keyComponentFactorDataList].sort((a, b) => b.iofp - a.iofp).slice(0, 10)
        }
      }

      return null
    },
    yearVOCsSortData () {
      const {yearAnalyzeMap} = this.rawData

      if (yearAnalyzeMap) {
        const {keyComponentFactorMap, vocRankingList} = yearAnalyzeMap
        const keyComponentFactorDataList = vocRankingList.reduce((list, data) => {
          for (let factorId in data) {
            const factor = keyComponentFactorMap[factorId]
            const factorData = data[factorId]

            if (factor) {
              const {mir} = factor

              if (mir) {
                const {avg} = factorData

                list.push({
                  id: factorId,
                  name: factorData.name,
                  unit: factor.stdUnit,
                  value: avg,
                  iofp: Number((avg * mir).toFixed(3)),
                  mir
                })
              }
            }
          }

          return list
        }, [])

        return {
          avgSortList: [...keyComponentFactorDataList].sort((a, b) => b.value - a.value).slice(0, 10),
          ofpSortList: [...keyComponentFactorDataList].sort((a, b) => b.iofp - a.iofp).slice(0, 10)
        }
      }

      return null
    },
    chapterIndex () {
      const rawData = this.rawData || {}
      return ['monthSituation', 'monthAnalyzeMap', 'yearSituationMap', 'yearAnalyzeMap'].filter(prop => rawData[prop]).reduce((map, prop, index) => {
        map[prop] = index + 1
        return map
      }, {})
    }
  },
  methods: {
    getDate () {
      const date = new Date()
      date.setMonth(date.getMonth() - 1)
      return date.format('YYYY/MM')
    }
  }
}
</script>

<style lang="scss" scoped>
.report-table {
  font-size: 14px;
  min-width: 100%;
  border-color: #ebeef5;
  white-space: nowrap;

  th,
  td {
    padding: 3px 5px;
  }

  th {
    background-color: #f9f9f9;
  }

  tr {
    &:nth-child(2n) {
      /*background-color: #fafafa;*/
    }

    &:hover {
      background-color: #f5f7fa !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/06Data-Management/03Report/01MonthReport/index.vue